import angular from 'angular';
import moment from "angular-moment";
import DateUtil from '../../../../components/logic/date_util/date_util.module';

import chartConfig from './power-stat-graph-demand.config';

export class PowerStatGraphDemandController {
  /*@ngInject*/
  constructor($scope, $interval, $filter, moment, DateUtil) {
    this.$interval = $interval;
    this.$filter = $filter;
    this.moment = moment;

    this.ticks = DateUtil.getXLabels;
    this.chartConfig = chartConfig(this);

    $scope.$watch('$ctrl.data.demandPower', newValue => this.updateGraph(newValue));
    $scope.$watch('$ctrl.data.type', () => this.reflowGraph());
  }

  $onInit() {}

  updateGraph(demandPowers) {
    if (!demandPowers || !this.chart) {
      return;
    }

    const graphData = this.createGraphData(demandPowers.current);

    this.chart.series[0].setData(graphData);
    this.chart.reflow();
  }

  createGraphData(powers) {
    powers = powers.filter(power => !power.missing);

    if (powers.length === 0) {
      return this.ticks.map(() => 0);
    }

    const timeAvgs = {};
    for(let time of this.ticks) {
      timeAvgs[time] = {count: 0, sum: 0};
    }

    for(let power of powers) {
      const time = this.moment(power.measured_at).format('HH:mm');
      timeAvgs[time].sum += power.value;
      timeAvgs[time].count += 1;
    }

    const graphData = [];
    for(let time of this.ticks) {
      let avg = 0;
      if (timeAvgs[time].count > 0) {
        avg = timeAvgs[time].sum / timeAvgs[time].count;
      }
      graphData.push(parseFloat(this.$filter('number')(avg, 2).replace(/,/g, '')));
    }

    return graphData;
  }

  reflowGraph() {
    if (!this.chart) {
      return;
    }
    this.$interval(() => {
      this.chart.redraw();
      this.chart.reflow();
    }, 500);
  }
}

export default angular.module('leptonApp.powerStatGraphDemand', [moment, DateUtil])
  .component('powerStatGraphDemand', {
    template: '<chart value="$ctrl.chartConfig"></chart>',
    controller: PowerStatGraphDemandController,
    bindings: {
      data: '='
    }
  })
  .name;



// WEBPACK FOOTER //
// ./public/dev/app/statistics_report/power-stat-graph/demand-power/power-stat-graph-demand.component.js